<script setup lang="ts">
import { Tab } from '@headlessui/vue'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { isPhone } from '@consumer/utils/breakpoints'

defineProps<{
  label: string
  icon: IconDefinition
  highlighted: boolean
}>()
</script>

<template>
  <Tab v-slot="{ selected }" as="template">
    <button
      class="
        relative
        border-1 border-solid border-grey-primary
        flex items-center justify-center leading-tight
        rounded-t-v2sm outline-none font-semibold
      "
      :class="[
        { highlighted },
        isPhone
          ? 'flex-col gap-0.5 py-2'
          : 'gap-2 py-4',
        selected
          ? 'bg-surface-grey border-b-surface-grey text-navy'
          : 'bg-white text-v2-secondary',
      ]"
    >
      <GIcon :icon="icon" size="xs"/>
      {{ label }}
    </button>
  </Tab>
</template>

<style scoped lang="scss">
:global {
  @keyframes highlight-tab {
    15%,
    50% {
      border-color: theme("colors.gold");
      box-shadow: 0 0 4px 1px theme("colors.gold");
    }

    30% {
      background-color: white;
    }
  }
}

.highlighted {
  animation: highlight-tab 4s ease-in-out;
  animation-delay: 1s;
}
</style>
